export const VI_MESSAGES = {
  APP: {
    TITLE: import.meta.env.VITE_APP_TITLE,
    SUBTITLE: import.meta.env.VITE_APP_DESCRIPTION,
  },
  
  NAVIGATION: {
    TABS: {
      WARDS: 'Phường/Xã',
      DIRECTIONS: 'Chỉ đường',
      COMPARE: 'So sánh',
    },
  },
  
  TABS: {
    WARDS: 'Phường/Xã',
    OFFICES: 'Trụ sở',
    ADDRESS_CONVERTER: 'Đổi địa chỉ',
  },
  
  PANEL: {
    TITLE: 'Công cụ',
    TOGGLE: 'Ẩn/Hiện thanh công cụ',
  },
  
  WARD: {
    LABELS: {
      NAME: 'Tên phường/xã',
      WARD_NAME: 'Tên phường',
      DISTRICT: 'Quận/Huyện',
      POPULATION: 'Dân số',
      AREA: 'Diện tích',
      DENSITY: 'Mật độ dân số',
      CHAIRMAN: 'Chủ tịch',
      BITHU: 'Bí thư',
      MTTQ: 'Chủ tịch MTTQ',
      PHONE: 'Điện thoại',
      EMAIL: 'Email',
      TOTAL: 'Tổng số',
    },
    UNITS: {
      POPULATION: 'người',
      AREA: 'km²',
      DENSITY: 'người/km²',
    },
    SEARCH_PLACEHOLDER: 'Tìm kiếm phường/xã...',
    NO_RESULTS: 'Không tìm thấy phường nào',
    ACTIONS: {
      GET_DIRECTIONS: 'Chỉ đường đến đây',
      VIEW_DETAILS: 'Xem chi tiết',
      CLEAR_FILTERS: 'Xóa bộ lọc',
    },
    FILTERS: {
      TITLE: 'Bộ lọc',
      DISTRICT: 'Xã/Phường',
      AREA_RANGE: 'Diện tích',
      POPULATION_RANGE: 'Dân số',
    },
    SORT: {
      NAME: 'Tên',
      AREA: 'Diện tích',
      POPULATION: 'Dân số',
    },
  },
  
  SEARCH: {
    PLACEHOLDER: 'Tìm kiếm phường/xã...',
    NO_RESULTS: 'Không tìm thấy kết quả',
    SEARCHING: 'Đang tìm kiếm...',
  },
  
  FILTER: {
    TITLE: 'Bộ lọc',
    DISTRICT: 'Chọn quận/huyện',
    ALL_DISTRICTS: 'Tất cả quận/huyện',
    AREA: {
      TITLE: 'Diện tích',
      MIN: 'Từ',
      MAX: 'Đến',
    },
    POPULATION: {
      TITLE: 'Dân số',
      MIN: 'Từ',
      MAX: 'Đến',
    },
    APPLY: 'Áp dụng',
    RESET: 'Đặt lại',
  },
  
  DIRECTIONS: {
    TITLE: 'Chỉ đường',
    SUBTITLE: 'Tìm đường đến phường/xã',
    ORIGIN: {
      LABEL: 'Điểm xuất phát',
      PLACEHOLDER: 'Nhập địa chỉ hoặc chọn trên bản đồ',
      CURRENT_LOCATION: 'Vị trí hiện tại',
    },
    DESTINATION: {
      LABEL: 'Điểm đến',
      PLACEHOLDER: 'Chọn phường/xã đích',
    },
    ORIGIN_PLACEHOLDER: 'Điểm xuất phát',
    DESTINATION_PLACEHOLDER: 'Điểm đến',
    TRAVEL_MODE: {
      LABEL: 'Phương tiện',
      CAR: 'Ô tô',
      WALK: 'Đi bộ',
      TRANSIT: 'Công cộng',
      BICYCLE: 'Xe đạp',
      DRIVING: 'Ô tô',
      WALKING: 'Đi bộ',
      CYCLING: 'Xe đạp',
    },
    ACTION: 'Chỉ đường',
    GET_DIRECTIONS: 'Chỉ đường',
    OPEN_IN_MAPS: 'Mở trong Google Maps',
    CURRENT_LOCATION: 'Vị trí hiện tại',
    SWAP: 'Đổi điểm đi và đến',
    NO_RECENT: 'Chưa có địa điểm gần đây',
    RECENT_DESTINATIONS: 'Điểm đến gần đây',
    LOCATION_ERROR: 'Không thể lấy vị trí hiện tại',
    LOCATION_NOT_SUPPORTED: 'Trình duyệt không hỗ trợ định vị',
    FILL_REQUIRED: 'Vui lòng nhập điểm xuất phát và điểm đến',
  },
  
  COMPARISON: {
    TITLE: 'So sánh phường/xã',
    SUBTITLE: 'Chọn tối đa 4 phường để so sánh',
    SELECT_WARDS: 'Chọn phường/xã từ danh sách để so sánh',
    MAX_SELECTION: 'Tối đa 4 phường/xã',
    SELECTED: 'Đã chọn',
    CLEAR: 'Xóa tất cả',
    COMPARE: 'So sánh',
    EXPORT: 'Xuất CSV',
    START_COMPARING: 'Bắt đầu so sánh',
    STOP_COMPARING: 'Dừng so sánh',
  },
  
  MAP: {
    LOADING: 'Đang tải bản đồ...',
    ZOOM_IN: 'Phóng to',
    ZOOM_OUT: 'Thu nhỏ',
    HOME: 'Về vị trí mặc định',
    LOCATE: 'Vị trí của tôi',
    LOCATION: 'Vị trí của tôi',
    LOCATION_ON: 'Đang theo dõi vị trí',
    LAYERS: 'Lớp bản đồ',
    BASEMAP: 'Bản đồ nền',
    VIEW_MODE: {
      TOGGLE_2D: 'Chuyển sang bản đồ phẳng',
      TOGGLE_3D: 'Chuyển sang bản đồ 3D',
      MODE_2D: 'Bản đồ phẳng',
      MODE_3D: 'Bản đồ 3D',
      NOT_SUPPORTED: '3D không được hỗ trợ trên thiết bị này',
    },
    BASEMAPS: {
      STREETS: 'Đường phố',
      SATELLITE: 'Vệ tinh',
      GRAY: 'Xám nhạt',
      OSM: 'OpenStreetMap',
    },
  },
  
  COMMON: {
    ALL: 'Tất cả',
    CLOSE: 'Đóng',
    CANCEL: 'Hủy',
    CONFIRM: 'Xác nhận',
    SAVE: 'Lưu',
    DELETE: 'Xóa',
    EDIT: 'Sửa',
    VIEW: 'Xem',
    EXPORT: 'Xuất',
    PRINT: 'In',
    SHARE: 'Chia sẻ',
    DIRECTIONS: 'Chỉ đường',
    RELOAD: 'Tải lại',
    LOADING: 'Đang tải...',
    ERROR: 'Đã xảy ra lỗi',
    SUCCESS: 'Thành công',
    NO_DATA: 'Không có dữ liệu',
    CLEAR: 'Xóa',
    CLEAR_ALL: 'Xóa tất cả',
  },
  
  MESSAGES: {
    OFFLINE: 'Không có kết nối mạng',
    LOCATION_PERMISSION: 'Vui lòng cho phép truy cập vị trí',
  },
  
  ERRORS: {
    GENERAL: 'Đã xảy ra lỗi. Vui lòng thử lại.',
    NETWORK: 'Lỗi kết nối mạng. Vui lòng kiểm tra kết nối của bạn.',
    NOT_FOUND: 'Không tìm thấy dữ liệu yêu cầu.',
    PERMISSION: 'Bạn không có quyền thực hiện thao tác này.',
  },
} as const

// Alias cho backward compatibility
export const VIETNAMESE_UI = VI_MESSAGES
